import React, { Component } from 'react';
import VASSlider from 'react-surveyjs-vas-widget';
// import { Survey, CustomWidgetCollection } from 'survey-react';
import * as Survey from "survey-react";
import _  from 'underscore';

import "survey-react/survey.css";
//  import "./testing.css"

class  BuildForm extends Component {
  constructor(props){
    super(props)
    this.state = {
      noerorrpage :  true,
      inputtext : false,
      inputboolean : false,
      complete: false,
      saving: false,
      type: 'text',
      textrequired : true,
      inputemail : false,
      inputetextarea : false,
      inputfile : false,
      inputhtml : false,
      passport:"passport",
      page : [],
      checkbox : false
     };
    //  this.props.noerorrpage(this.state.noerorrpage)

    
    }
  json = {
    elements: [
     { type: "text", name: "judge ", title: "What is your name?", isRequired: true},
     
    ]
  
     
     
   };

   componentDidMount(){
    // console.log("page data----->", this.json.pages[0].elements)
  
    this.setState({
      page:this.json.elements,
      loading:true
    })
      // console.log("page state=====--->",this.state.page, this.json.elements)
       

   }



    onComplete(survey, options) {
      //Write survey results into database
      // console.log("Survey results: " + JSON.stringify(survey.data));
     }

     inputText=(e)=>{
       e.preventDefault();
      //  console.log("event====>",e)
       this.setState({
          inputtext:true
       })
      }
      closeAll=(e)=>{
        e.preventDefault();
        // console.log("event====>",e)
        this.setState({
           inputtext:false,
           inputboolean :false,
           inputemail : false,
           inputetextarea :false,
           inputfile:false,
           inputhtml:false,
           checkbox:false
        })
      }
      textrequired=()=>{
        this.setState({
          textrequired: !this.state.textrequired,
          });
          // console.log("check Trucking", this.state.textrequired)
      }
      inputBoolean =(e)=>{
        e.preventDefault();
        this.setState({
          inputboolean :true
        })
      }
      inputeTextarea =(e)=>{
        e.preventDefault();
        this.setState({
          inputetextarea :true
        })
        // console.log("check text", this.state.inputetextarea) 
      }
      inputEmai = (e) =>{
        e.preventDefault();
        this.setState({
          inputemail:true
        })
        // console.log("check email", this.state.inputemail) 
      }

      inputFile=(e)=>{
        e.preventDefault();
        this.setState({
         inputfile : true
        })
        // console.log("check email", this.state.inputfile) 
      }

      checkBox=(event)=>{
        event.preventDefault
        this.setState({
          checkbox : true
          })
        //  console.log("data", event)
      }

   

      inputDisplay = (e)=>{
        e.preventDefault();
      
        this.setState({
         inputhtml : true
        })
        // console.log("check email", this.state.inputhtml) 
       
  
       }
      

      handleChange=(event)=> {
        this.setState({type: event.target.value});
        // console.log("loggggg------>", this.state.type)
      }

      passportChange=(event)=> {
        if(event.target.value == "passport"){
          this.setState({passport: "passport"});
          // console.log("passport------>  passport", )
        }else{
          this.setState({
            passport:"fileimage"
          });
          // console.log(" ------> fileimage")
        }
       
      }

    
     addTextinput=(e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
    //   console.log("random========", r, this.generateId());
       const   data = {
            type: "text",
            id :this.generateId(),
            name:this.name.value,
            title :this.title.value,
            placeholder : this.placeholder.value,
            inputType : this.state.type,
            required : this.state.textrequired ,
            isRequired : this.state.textrequired ,
          }

          // const page  = this.json.pages[0].elements
          this.props.addTopage(data)
          this.setState({
            inputtext:false,
         })

     } 

     addboolean = (e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
      const   data = {
           id :this.generateId(),
           type: "boolean",
           name:this.name.value,
           title :this.title.value,
           required : this.state.textrequired ,
           isRequired : this.state.textrequired ,
         }
         this.props.addTopage(data)
   
            this.setState({
                inputboolean :false,
            })
     }

     addEmail = (e)=>{
      e.preventDefault();
      // console.log("event====> email",this.name.value, this.title.value)
    
       const   data = {
            type: "text",
            inputType: "email",
            id :this.generateId(),
            name:this.name.value,
            title :this.title.value,
            placeholder : this.placeholder.value,
            //  inputType : this.state.type,
            required : this.state.textrequired ,
            isRequired : this.state.textrequired ,
            validators: [
              {
               type: "email"
              }
             ],
          }
          this.props.addTopage(data)
          this.setState({
            inputemail : false,
         })
          
     }

     addFileinput=(e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
       const   data = {
            type:"file",
            passport:this.state.passport,
            "maxSize": "0",
            id :this.generateId(),
            name:this.state.passport,
            title :this.title.value,
            // placeholder : this.placeholder.value,
            // inputType : this.state.type,
            required : this.state.textrequired ,
            isRequired : this.state.textrequired ,
          }
          this.props.addTopage(data)
          this.setState({
            inputfile : false,
         })
     }

     

     addtextarea= (e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
       const   data = {
           id :this.generateId(),
            type: "comment",
            name:this.name.value,
            title :this.title.value,
            placeholder : this.placeholder.value,
            isRequired : this.state.textrequired ,
            // inputType : this.state.type,
            required : this.state.textrequired ,
          }
          this.props.addTopage(data)
          this.setState({
            inputetextarea :false
 
         })
         
     }

     addCheckbook=(event)=>{
      event.preventDefault
      // console.log("data new one", event)
     const  item = [
          this.item1.value,
           this.item2.value
     ]
      const   data = {
         id :this.generateId(),
         type: "checkbox",
         choices: item,
         name:this.name.value,
         isRequired : this.state.textrequired ,
         // inputType : this.state.type,
         required : this.state.textrequired ,
       }
       this.props.addTopage(data)
          this.setState({
            checkbox :false
 
         })
     }

     addDisplay=(e)=>{
      e.preventDefault();
      // console.log("event====>",this.name.value, this.title.value)
      const   data = {
           id :this.generateId(),
           type: "html",
           html:this.body.value,
         }
         this.props.addTopage(data)
         this.setState({
          inputhtml :false

        })
        

     }

   

     dec2hex= (dec)=> {
        return ('0' + dec.toString(16)).substr(-2)
      }
       generateId =(len)=> {
        var arr = new Uint8Array((len || 20) / 2)
        window.crypto.getRandomValues(arr)
        return Array.from(arr, this.dec2hex).join('')
      }
     


  render() {
  
    // var model = new Survey.Model(this.json);
    // var model = new Survey.Model(this.state.page);
    // console.log("data of state", this.state.page)
    return (
                <div className="Home"> 
                      <div className="page-testing">
                      
                              <div>
                                {
                                  this.state.inputtext == true ? (
                                  <form onSubmit={this.addTextinput} >
                                        <div className="texting-input-body">
                                          <div className="texting-input-title">
                                                Enter text input details 
                                            </div>
                                          <div className="field form-body-area">
                                              <div className="control">
                                                  <input className="input" type="text" 
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.name = input} 
                                                  placeholder="Enter input name" required/>
                                              </div>
                                              <br/>
                                              <div className="control">
                                                  <input className="input" type="text"
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.title = input} 
                                                    placeholder="Enter input title" required/>
                                              </div>
                                              <br/>
                                              <div className="control">
                                                  <input className="input" type="text"
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.placeholder = input} 
                                                    placeholder=" Enter PlaceHolder" required/>
                                              </div>
                                              <br/>
                                              
                                                
                                               <label className="checkbox testing-input-required">
                                                  <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                       The you want it to be required
                                                </label>

                                                <div className="select testing-input-magin">
                                                  <select value={this.state.type} onChange={this.handleChange}>
                                                    <option value="tel">tel</option>
                                                    <option value="text">text</option>
                                                    <option value="date">date</option>
                                                    <option value="number">number</option>
                                                  </select>
                                               </div> 
                                                <br/>
                                                <br/>

                                                  {/* <input  className="checkbox"  checked={this.state.textrequired} onChange={this.textrequired} type="checkbox"/> */}
                                            </div>
                                        </div>
                                          <div>
                                            <button className="button is-success is-small is-rounded">Submit</button>  |   
                                            <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                          </div>
                                      </form>  
                                  ) :this.state.inputboolean == true ? (
                                    <div>
                                      <form onSubmit={this.addboolean} >
                                        <div className="texting-input-body">
                                           <div className="texting-input-title">
                                               Enter details of your condition input
                                            </div>
                                          <div className="field form-body-area">
                                              <div className="control">
                                                  <input className="input" type="text" 
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.name = input} 
                                                  placeholder="Example the you love music"/>
                                              </div>
                                              <div className="control">
                                                  <input className="input" type="text" 
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.title = input} 
                                                  placeholder="Example the you love music"/>
                                              </div>
                                              <label className="checkbox testing-input-required">
                                                  <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                       The you want it to be required
                                              </label>
                                          </div>
                                        </div>
                                          <div>
                                            <button className="button is-success is-small is-rounded">Submit</button>  |   
                                            <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                          </div>
                                      </form>  
                                    </div>
                                  ):this.state.inputemail == true ? (
                                     <div>   
                                          <form onSubmit={this.addEmail} >
                                            <div className="texting-input-body">
                                              <div className="texting-input-title">
                                                    Enter  email input details
                                                </div>
                                              <div className="field form-body-area">
                                                  <div className="control">
                                                      <input className="input" type="text" 
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.name = input} 
                                                      placeholder="Enter input name" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.title = input} 
                                                        placeholder="Enter input title" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.placeholder = input} 
                                                        placeholder=" Enter PlaceHolder" required/>
                                                  </div>
                                              
                                                  <label className="checkbox testing-input-required">
                                                      <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                          The you want it to be required
                                                    </label>

                                                      
                                                </div>
                                            </div>
                                             <div>
                                              <button className="button is-success is-small is-rounded">Submit</button>  |   
                                              <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                             </div>
                                      </form>   
                                    </div>
                                     ):this.state.inputetextarea == true ? (
                                          <div> 
                                             <form onSubmit={this.addtextarea} >
                                               <div className="texting-input-body">
                                                  <div className="texting-input-title">
                                                     Enter details of Testarea
                                                 </div>
                                              <div className="field form-body-area">
                                                  <div className="control">
                                                      <input className="input" type="text" 
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.name = input} 
                                                      placeholder="Enter input name" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.title = input} 
                                                        placeholder="Enter input title" required/>
                                                  </div>
                                                  <br/>
                                                  <div className="control">
                                                      <input className="input" type="text"
                                                      // onChange={this.upDatenote}
                                                      ref={ input => this.placeholder = input} 
                                                        placeholder=" Enter PlaceHolder" required/>
                                                  </div>
                                              
                                                  <label className="checkbox testing-input-required">
                                                      <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                          The you want it to be required
                                                    </label>

                                                      
                                                </div>
                                            </div>
                                          <div>
                                             <button className="button is-success is-small is-rounded">Submit</button>  |   
                                              <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                          </div>
                                      </form>   
                                          </div>
                                      )
                                      :this.state.inputfile == true ? (
                                        <div> 
                                           <form onSubmit={this.addFileinput} >
                                             <div className="texting-input-body">
                                                <div className="texting-input-title">
                                                   Enter details of File input
                                               </div>
                                            <div className="field form-body-area">
                                                {/* <div className="control">
                                                    <input className="input" type="text" 
                                                    // onChange={this.upDatenote}
                                                    ref={ input => this.name = input} 
                                                    placeholder="Enter input name" required/>
                                                </div> */}
                                                <br/>
                                                <div className="control">
                                                    <input className="input" type="text"
                                                    // onChange={this.upDatenote}
                                                    ref={ input => this.title = input} 
                                                      placeholder="Enter input title" required/>
                                                </div>
                                                <br/>
                                              
                                                <br/>
                                                <label className="checkbox testing-input-required">
                                                  <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                       The you want it to be required
                                                </label>

                                                <div className="select testing-input-magin">
                                                  <select value={this.state.passport} onChange={this.passportChange}>
                                                    <option value="passport">Passport</option>
                                                    <option value="fileimage">File </option>
                                                  </select>
                                               </div>
                                                    <br/>
                                                    <br/>
                                            
                                              </div>
                                              
                                          </div>

                                        <div>
                                           <button className="button is-success is-small is-rounded">Submit</button>  |   
                                            <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                        </div>
                                        
                                    </form>   
                                        </div>
                                    ):this.state.checkbox === true ? (
                                      <div> 
                                         <form onSubmit={this.addCheckbook} >
                                           <div className="texting-input-body">
                                              <div className="texting-input-title">
                                                Create checkbox 
                                             </div>
                                          <div className="field form-body-area">
                                              <div className="control">
                                                  <input className="input" type="text" 
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.name = input} 
                                                  placeholder="Enter input name" required/>
                                              </div>
                                              <br/>
                                              <div className="control">
                                                  <input className="input" type="text"
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.item1 = input} 
                                                    placeholder="Enter item 1" required/>
                                              </div>
                                              <br/>
                                              <div className="control">
                                                  <input className="input" type="text"
                                                  // onChange={this.upDatenote}
                                                  ref={ input => this.item2 = input} 
                                                    placeholder="Enter item 2" required/>
                                              </div>
                                        
                                          
                                              <label className="checkbox testing-input-required">
                                                  <input type="checkbox" checked={this.state.textrequired} onChange={this.textrequired}/>
                                                      The you want it to be required
                                                </label>

                                                  
                                            </div>
                                        </div>
                                      <div>
                                         <button className="button is-success is-small is-rounded">Submit</button>  |   
                                          <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                      </div>
                                  </form>   
                                      </div>
                                  )
                                    :this.state.inputhtml == true ? (
                                      <div> 
                                         <form onSubmit={this.addDisplay} >
                                           <div className="texting-input-body">
                                              <div className="texting-input-title">
                                                 Enter details of File input
                                             </div>
                                          <div className="field form-body-area">
                                    
                                    
                                              <textarea className="textarea "  rows="4" cols="90" 
                                                  value={this.state.body} onChange={this.upDatenote} 
                                                  ref={ input => this.body = input}    placeholder="Description" required>
                                              </textarea>
                                                    
                                              </div>
                                          </div>
                                        <div>
                                          <button className="button is-success is-small is-rounded">Submit</button>  |   
                                            <button className="button is-success is-small is-inverted is-rounded" onClick={this.closeAll}>Close</button>
                                        </div>
                                     </form>   
                                   </div> )
                                    :

                                      <div className="texting-body-button">
                                        <div className="tile is-parent">
                                          <article className="tile is-child box">
                                            <a className="button is-success is-outlined is-fullwidth build-frombuild-button" onClick={this.inputText}>
                                              <i className="fas fa-text-width build-frombuild-button-p"> </i> Text input
                                            </a>
                                          <a className="button is-success is-outlined is-fullwidth build-frombuild-button" onClick={this.inputeTextarea}>
                                             <i className="fas fa-comment-dots build-frombuild-button-p"></i>Textarea input
                                          </a>
                                          <a className="button is-success is-outlined is-fullwidth build-frombuild-button" onClick={this.inputEmai}>
                                            <i className="fas fa-at build-frombuild-button-p"></i> Email input
                                          </a>
                                          <a className="button is-success is-outlined is-fullwidth build-frombuild-button" onClick={this.inputBoolean}>
                                          <i className="far fa-check-square build-frombuild-button-p"></i>Boolean
                                          </a>
                                          <a className="button is-success is-outlined is-fullwidth build-frombuild-button" onClick={this.inputFile}>
                                               <i className="far fa-file build-frombuild-button-p"></i>  File input
                                           </a>
                                           <a className="button is-success is-outlined is-fullwidth build-frombuild-button" onClick={this.checkBox}>
                                               <i className="fas fa-tasks build-frombuild-button-p"></i>  Checkbox
                                           </a>
                                          
                                            <a className="button is-success is-outlined is-fullwidth build-frombuild-button" onClick={this.inputDisplay}>
                                            <i className="fas fa-code build-frombuild-button-p"></i> Display html </a>
                                          
                                          </article>
                                        </div>

                                        <div className="formbuild-display-moblie">
                                           <a className="button is-success is-outlined " onClick={this.inputText}>
                                              <i className="fas fa-text-width build-frombuild-button-p"> </i> 
                                            </a>
                                          <a className="button is-success is-outlined" onClick={this.inputeTextarea}>
                                             <i className="fas fa-comment-dots build-frombuild-button-p"></i>
                                          </a>
                                          <a className="button is-success is-outlined " onClick={this.inputEmai}>
                                            <i className="fas fa-at build-frombuild-button-p"></i> 
                                          </a>
                                          <a className="button is-success is-outlined " onClick={this.inputBoolean}>
                                          <i className="far fa-check-square build-frombuild-button-p"></i>
                                          </a>
                                          <a className="button is-success is-outlined " onClick={this.inputFile}>
                                               <i className="far fa-file build-frombuild-button-p"></i>  
                                           </a>
                                           <a className="button is-success is-outlined " onClick={this.checkBox}>
                                               <i className="fas fa-tasks build-frombuild-button-p"></i> 
                                           </a>
                                          
                                            <a className="button is-success is-outlined " onClick={this.inputDisplay}>
                                            <i className="fas fa-code build-frombuild-button-p"></i> </a>
                                        </div>
                                         
                                         
                                      </div>
                                     
                                 } 
                           </div> 
                        </div>
                    </div>
            )
        }
    }    

  export default BuildForm ;      





// WEBPACK FOOTER //
// ./src/component/create/frombuild.js